import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";

export const Testimonials = () => {
  return (
    <section id="avis" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32">
      <div className="mb-14">
        <span className="text-xs tracking-[0.25em] uppercase text-mh-orange font-bold">Avis clients</span>
        <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl tracking-tight text-white leading-[0.95] max-w-2xl">
          Ils nous ont fait confiance
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <motion.blockquote
            key={i}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="border border-mh-line bg-mh-bg2 p-8 flex flex-col"
            data-testid={`testimonial-${i}`}
          >
            <Quote className="text-mh-orange mb-5" size={28} />
            <div className="flex gap-1 mb-4">
              {[...Array(5)].map((_, s) => (
                <Star key={s} size={14} className="fill-mh-orange text-mh-orange" />
              ))}
            </div>
            <p className="text-white/90 leading-relaxed flex-1">"{t.text}"</p>
            <footer className="mt-6 pt-6 border-t border-mh-line">
              <div className="font-display font-bold text-white">{t.name}</div>
              <div className="text-xs tracking-[0.15em] uppercase text-mh-slate mt-1">{t.city}</div>
            </footer>
          </motion.blockquote>
        ))}
      </div>
    </section>
  );
};
